import axios from 'axios';
import { auth } from '../firebase-config';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
const CONTESTS_API = `${API_BASE_URL}/api/contests`;

const getAuthHeaders = async (userAuth) =>
{
  const user = userAuth || auth.currentUser;
  if (!user)
  {
    return {};
  }

  const token = await user.getIdToken();
  return {
    Authorization: `Bearer ${token}`
  };
};

export const fetchContestMCQs = async (contestId, userAuth) =>
{
  try
  {
    const headers = await getAuthHeaders(userAuth);
    const response = await axios.get(
      `${CONTESTS_API}/${contestId}/mcqs`,
      { headers }
    );
    return response.data.mcqs || [];
  }
  catch (error)
  {
    console.error('Error fetching MCQs:', error);
    return [];
  }
};

export const registerUserForContestAuth = async (contestId, userAuth) =>
{
  try
  {
    const headers = await getAuthHeaders(userAuth);
    const response = await axios.post(
      `${CONTESTS_API}/${contestId}/register`,
      {},
      { headers }
    );

    return response.data;
  }
  catch (error)
  {
    console.error('Error registering user:', error);
    return {
      success: false,
      error: error.response?.data?.error || error.message
    };
  }
};

export const checkUserRegistration = async (contestId, userAuth) =>
{
  try
  {
    const headers = await getAuthHeaders(userAuth);
    const response = await axios.get(
      `${CONTESTS_API}/${contestId}/registration`,
      { headers }
    );

    return Boolean(response.data.registered);
  }
  catch (error)
  {
    console.error('Error checking registration:', error);
    return false;
  }
};

export const checkSubmission = async (contestId, userAuth) =>
{
  try
  {
    const headers = await getAuthHeaders(userAuth);
    const response = await axios.get(
      `${CONTESTS_API}/${contestId}/submission`,
      { headers }
    );

    return Boolean(response.data.submitted);
  }
  catch (error)
  {
    console.error('Error checking the submission:', error);
    return false;
  }
};

export const submitContestResult = async (resultData) =>
{
  try
  {
    const headers = await getAuthHeaders();
    const response = await axios.post(
      `${CONTESTS_API}/${resultData.contestId}/results`,
      {
        answers: resultData.answers
      },
      { headers }
    );

    return response.data;
  }
  catch (error)
  {
    console.error('ERROR submitting contest result:', error);
    return {
      success: false,
      error: error.response?.data?.error || error.message
    };
  }
};

export const addMCQToContest = async (contestId, mcqData, creator) =>
{
  try
  {
    const headers = await getAuthHeaders();
    const response = await axios.post(
      `${CONTESTS_API}/${contestId}/mcqs`,
      {
        mcqData,
        userName: creator
      },
      { headers }
    );

    return response.data;
  }
  catch (error)
  {
    console.error('Error adding MCQ:', error);
    return {
      success: false,
      error: error.response?.data?.error || error.message
    };
  }
};

export const updateContestMCQImage = async (contestId, mcqId, imageUrl) =>
{
  try
  {
    const headers = await getAuthHeaders();
    const response = await axios.patch(
      `${CONTESTS_API}/${contestId}/mcqs/${mcqId}/image`,
      { imageUrl },
      { headers }
    );

    return response.data;
  }
  catch (error)
  {
    console.error('Error updating contest MCQ image:', error);
    return {
      success: false,
      error: error.response?.data?.error || error.message
    };
  }
};
